export default __webpack_public_path__ + "static/media/z040mi0b.35268e88.mp3";